import angular from "angular";
import Novinky from "./Novinky";

export default angular.module("antes.novinky", [])
.directive("antesNovinky", Novinky)
.name


// WEBPACK FOOTER //
// ./src/novinky/index.js